import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateQuestion } from "../../services/question";
import { IIndicators } from "../../types/indicator";
import { toast } from "react-toastify";

const useUpdateQuestion = (indicator: IIndicators) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateQuestion,
        onMutate: () => {
            indicator.setIsProcessRunning(true);
            indicator.setIsServiceError(null);
        },
        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ['questionnaire_content'] });
                indicator.setIsProcessRunning(false);
                indicator.setIsServiceError(null);
                toast.success("Question updated successfully");
            }
        },

        onError: (error: any) => {
            indicator.setIsServiceError(error?.response?.data?.message);
            indicator.setIsProcessRunning(false);
            toast.error(error?.response?.data?.message);
        }
    });
}

export default useUpdateQuestion;